"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.A = void 0;
const Analytics_1 = require("./Analytics");
class A {
    /**
     * Creates an analytics 'a' function for easy triggering of events.
     * @param payload basic payload that is added to each payload of the returned
     * function call.
     * @returns a function for triggering analytics events
     * @example
     * ```typescript
     * // Creates a function and sets the basic payload.
     * const a = A.of({ sceneType: 'HOME', sceneId: 'home' });
     *
     * // Sends 'scene_view' event with the basic payload.
     * a('scene_view');
     *
     * // Sends 'buffering_stop' with shallow merge of the basic payload and { asset } object.
     * a('buffering_stop', { asset });
     * ```
     */
    static of(payload) {
        const a = ((eventName, eventPayload) => {
            Analytics_1.analytics.triggerEvent(eventName, Object.assign(Object.assign({}, a.payload), eventPayload));
        });
        a.payload = payload;
        a.addToPayload = (extendedPayload) => {
            a.payload = Object.assign(Object.assign({}, a.payload), extendedPayload);
        };
        a.setPayload = (newPayload) => {
            a.payload = newPayload;
        };
        a.clearPayload = () => {
            a.payload = {};
        };
        return a;
    }
}
exports.A = A;
